module.exports = __webpack_public_path__ + "19945ece62641e554d4de17d2768b9a8.MP3";